import React from 'react'
import { ModalWrapper } from '../../../../../../components'
import { Avatar, Divider, Typography } from '@mui/material'
import { InfoField } from '../../School/PopOver/SchoolInfo'
import { QRicon } from '../../../../../../assets/icons'
import { useSelector } from 'react-redux'
import { QRCodeDisplay } from '../../School/SchoolRegistration/components/Steps'
import { formatDate } from '../../../../../../components/Table/TableCells/TableCell'

const EmployeeDetail = ({ open, handleClose }) => {
  const data = useSelector((state) => state.global.SchoolDInfo)
  const [downloadQR, setDownload] = React.useState(false)
  return (
    <ModalWrapper
      open={open}
      handleClose={handleClose}
      title={'Employee Detail'}
      width={'fit-content'}
    >
      <div className="add-employee">
        <Typography mb={2} className="form-heading">
          Personal Information
        </Typography>
        <div className="emp-det-head">
          <div>
            <Typography className="field-label">Avatar</Typography>
            {data?.employee_avatar ? (
              <img src={data?.employee_avatar} alt="" className="employee-img" />
            ) : (
              <Avatar
                alt={''}
                sx={{
                  width: '76px',
                  height: '76px',
                  mt: 1,
                  fontSize: '30px',
                  backgroundColor: '#F2ECF9',
                  color: '#492972',
                }}
              >
                {data?.employee_name?.charAt(0).toUpperCase()}
              </Avatar>
            )}
          </div>
          <div className="download-qr-block" onClick={() => setDownload(true)}>
            <img src={QRicon} alt="" />
            <Typography className="download-qr">Show QR Code</Typography>
          </div>
          {downloadQR && (
            <QRCodeDisplay
              name={data?.employee_name}
              open={downloadQR}
              handleClose={() => setDownload(false)}
              value={data?.employee_id}
            />
          )}
        </div>
        <div className="text-fields">
          <InfoField label={'Name'} value={data?.employee_name} width={'200px'} />
          <InfoField label={'Type'} value={data?.employee_type} width={'200px'} />
        </div>
        <div className="text-fields">
          <InfoField
            label={'Contact Number'}
            value={data?.employee_contact_number}
            width={'200px'}
          />

          <InfoField label={'Email'} value={data?.employee_email} width={'200px'} />
        </div>
        <InfoField label={'Date of Birth'} value={formatDate(data?.employee_dob)} width={'200px'} />

        <Divider />
        <Typography mt={2} mb={2} className="form-heading">
          Other Information
        </Typography>
        <div className="text-fields">
          <InfoField label={'Salary'} value={data?.employee_salary} width={'200px'} />
          <InfoField
            label={'Joining Date'}
            value={formatDate(data?.employee_joining_date)}
            width={'200px'}
          />
        </div>
        <div className="text-fields">
          <InfoField label={'Address'} value={data?.employee_address} width={'200px'} />
          <InfoField label={'Address 2'} value={data?.employee_address_two} width={'200px'} />
        </div>
        <div className="text-fields">
          <InfoField label={'City'} value={data?.employee_city} width={'150px'} />
          <InfoField label={'State'} value={data?.employee_state} width={'120px'} />
          <InfoField label={'Zip'} value={data?.employee_pincode} width={'120px'} />
        </div>
      </div>
    </ModalWrapper>
  )
}

export default EmployeeDetail
